<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="half-title"><a id="page_ix"></a>The<br/><span class="big">Sword-Edged</span><br/><span class="big">Blonde</span></p>
<p class="image"><img alt="Image" src="line1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?728d89fe